import { AfterViewInit, Component, computed, inject, input, output, TemplateRef, viewChild } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'adspt-toaster',
  templateUrl: './toaster.component.html',
  imports: [NzIconModule, IconComponent],
})
export class ToasterComponent implements AfterViewInit {
  private notification = inject(NzNotificationService);
  readonly title = input<string>();
  readonly placement = input<'bottomLeft' | 'bottomRight'>('bottomLeft');
  readonly duration = input<number>();
  readonly type = input<'success' | 'info' | 'warning' | 'error' | 'blank' | string>();
  readonly icon = computed(() => {
    switch (this.type()) {
      case 'success':
        return 'check-circle';

      case 'error':
        return 'close-circle';

      case 'warning':
        return 'alert-triangle';

      case 'info':
        return 'alert-info';

      default:
        return null;
    }
  });

  readonly closed = output<boolean>();
  readonly template = viewChild(TemplateRef);
  // @ViewChild(TemplateRef, { static: false }) template: TemplateRef<{ $implicit: NzNotificationComponent; data: any }>;
  ngAfterViewInit() {
    this.notification
      .template(this.template(), {
        nzPlacement: this.placement(),
        nzDuration: this.duration() || 15000,
        nzPauseOnHover: true,
        nzAnimate: true,
        nzClass: `adspt-toast ${this.type()}`,
        nzCloseIcon: 'cross',
      })
      .onClose.subscribe(() => this.closed.emit(true));
  }
}
